import React, { useState, useEffect } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { CoreAutoComplete, CoreButton } from 'src/components/core'
import { PatchContent, PatchData } from 'src/model/patch'
import { coursePatchAction } from 'src/reducers/course/action'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { getCollectionList } from 'src/reducers/collection/action'
import { useParams } from 'react-router-dom'
const MoveTo = ({ course, setLocalCourses, localCourses, classes }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const collectionQuery = {
      filterText: '',
      currentPage: 0,
      pageSize: 100,
      sortingColumn: 'createdAt',
      asc: false,
    }
    dispatch(getCollectionList(collectionQuery, () => {}))
  }, [dispatch])
  const collectionList = useSelector(state => state.collection.list)
  const [selectedCollection, setSelectedCollection] = useState(null)
  const coursePage = window.location.pathname.split('/')[1]

  useEffect(() => {
    if (collectionList && collectionList.length > 0) {
      // Filter out the current collection if course is in one
      const filteredCollections = collectionList.filter(
        collection => collection.id !== course.courseCollectionId,
      )
      setSelectedCollection(filteredCollections[0] || null)
    }
  }, [collectionList, course.courseCollectionId])

  const handleCollectionChange = (event, value) => {
    setSelectedCollection(value)
  }

  const handleMoveCourse = () => {
    if (!course) return

    const patchSource = new PatchData(null, course.id)

    if (selectedCollection === null) {
      // Unbind course from collection
      patchSource.addContent(
        new PatchContent(
          null,
          'courseCollectionId',
          PatchData.OPERATION_REPLACE,
        ),
      )
      patchSource.addContent(
        new PatchContent(
          0,
          'courseCollectionOrder',
          PatchData.OPERATION_REPLACE,
        ),
      )
    } else {
      // Move to selected collection
      patchSource.addContent(
        new PatchContent(
          selectedCollection.id,
          'courseCollectionId',
          PatchData.OPERATION_REPLACE,
        ),
      )
      patchSource.addContent(
        new PatchContent(
          selectedCollection.courses ? selectedCollection.courses.length : 0,
          'courseCollectionOrder',
          PatchData.OPERATION_REPLACE,
        ),
      )
    }

    setLocalCourses(
      localCourses.filter(filterCourse => filterCourse.id !== course.id),
    )
    dispatch(coursePatchAction(patchSource))
    dispatch(messageBoxHideAction('message-box-1'))
  }

  const handleCancel = () => {
    dispatch(messageBoxHideAction('message-box-1'))
  }
  const isCollectionPage = window.location.pathname.includes('collection')

  // Filter out current collection from the list
  const filteredCollections = collectionList.filter(
    collection => collection.id !== course.courseCollectionId,
  )

  return (
    <div style={styles.container}>
      <CoreAutoComplete
        marginTop={true}
        fullWidth
        label="Learning path"
        value={selectedCollection}
        selectOnFocus
        options={
          isCollectionPage && course.courseCollectionId !== null
            ? [{ id: null, name: 'Remove from path' }, ...filteredCollections]
            : [...filteredCollections]
        }
        getOptionLabel={option => option?.name || ''}
        getOptionSelected={(option, value) => option?.id === value?.id}
        onChange={handleCollectionChange}
        freeSolo={false}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
          marginTop: '16px',
        }}
      >
        <CoreButton variant="text" color="secondary" onClick={handleCancel}>
          Cancel
        </CoreButton>
        <CoreButton
          variant="contained"
          color="primary"
          onClick={handleMoveCourse}
          disabled={selectedCollection === null && coursePage === 'courses'}
        >
          {selectedCollection === null ? 'Remove from path' : 'Move course'}
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(MoveTo)
